import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlWithStateModel } from '@apps-common/types/portal/unit-control'

const updateMyMonitoringDefaultControl = async (model: IUnitControlWithStateModel): Promise<boolean> =>
  axios.post(`/my-monitoring/control/UpdateDefaultControl`, model).then((res) => res?.data?.result)

type Props = {
  model: IUnitControlWithStateModel
}

export const useMyMonitoringUpdateDefaultControl = (notify?: boolean, onSuccess?: (data: boolean) => void, onError?: () => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringDefaultControl'],
    mutationFn: ({ model }: Props) => updateMyMonitoringDefaultControl(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated default control.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update default control, please try again.')
      }
      if (onError) {
        onError()
      }
    },
    throwOnError: false
  })
